import { css } from '@emotion/core';

export const colorsButton = {
  blue: {
    hover: 'var(--color-button-secondary-hover)',
    default: 'var(--color-button-secondary-default)',
  },
  green: {
    hover: 'var(--color-button-primary-hover)',
    default: 'var(--color-button-primary-default)',
  },
  red: {
    hover: 'var(--color-button-warning-hover)',
    default: 'var(--color-button-warning-default)',
  },
  lightRed: {
    hover: 'var(--color-button-warning-pressed)',
    default: 'var(--color-button-warning-default)',
  },
  iconGray: {
    hover: 'var(--color-button-tertiary-hover)',
    default: 'var(--color-button-tertiary-default)',
  },
  brokenRed: {
    hover: 'var(--color-button-warning-pressed)',
    default: 'var(--color-feedback-error)',
  },
  iconWhite: {
    hover: 'var(--color-background-white)',
    default: 'var(--color-background-light)',
  },
};

export const shadow = css`
  box-shadow: 0 18px 26px
    color-mix(in srgb, var(--color-background-black) 6%, transparent);
`;

export const shadowLight = css`
  box-shadow: 0 18px 26px
    color-mix(in srgb, var(--color-background-black) 3%, transparent);
`;

export const shadowOverlay = css`
  box-shadow: 0 1px 3px
    color-mix(in srgb, var(--color-background-black) 10%, transparent);
`;

export const border = css`
  border-width: 1px;
  border-color: var(--color-border-medium);
  border-style: solid;
  border-radius: 8px;
`;

export const borderTight = css`
  border-width: 1px;
  border-color: var(--color-border-medium);
  border-style: solid;
  border-radius: 4px;
`;

export const dropdownColors = {
  hover: 'var(--color-background-hover)',
};
